module.exports = __webpack_public_path__ + "static/media/landing-page-photo-v3.e436cbed.jpg";